/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * A list of claim definitions.
 */
export type ClaimsSchemaFieldsItem =
    | Truvity.ClaimsSchemaFieldsItem.Boolean
    | Truvity.ClaimsSchemaFieldsItem.Date_
    | Truvity.ClaimsSchemaFieldsItem.Datetime
    | Truvity.ClaimsSchemaFieldsItem.File_
    | Truvity.ClaimsSchemaFieldsItem.Link
    | Truvity.ClaimsSchemaFieldsItem.Number
    | Truvity.ClaimsSchemaFieldsItem.String
    | Truvity.ClaimsSchemaFieldsItem.Struct;

export namespace ClaimsSchemaFieldsItem {
    export interface Boolean extends Truvity.ClaimsSchemaFieldBooleanValue {
        kind: 'BOOLEAN';
    }

    export interface Date_ extends Truvity.ClaimsSchemaFieldDateValue {
        kind: 'DATE';
    }

    export interface Datetime extends Truvity.ClaimsSchemaFieldDateTimeValue {
        kind: 'DATETIME';
    }

    export interface File_ extends Truvity.ClaimsSchemaFieldFileValue {
        kind: 'FILE';
    }

    export interface Link extends Truvity.ClaimsSchemaFieldLinkValue {
        kind: 'LINK';
    }

    export interface Number extends Truvity.ClaimsSchemaFieldNumberValue {
        kind: 'NUMBER';
    }

    export interface String extends Truvity.ClaimsSchemaFieldStringValue {
        kind: 'STRING';
    }

    export interface Struct extends Truvity.ClaimsSchemaFieldStructValue {
        kind: 'STRUCT';
    }
}
